import React, { createContext, useEffect, useState } from "react";

import { UncontrolledCollapsibleContainer } from "../Collapsible";

const CollapsibleGroupContext = createContext();
CollapsibleGroupContext.displayName = "CollapsibleGroupContext";

export const UncontrolledCollapsibleGroup = ({
    current,
    onChange,
    collapsibleStyle,
    ...props
}) => (
    <CollapsibleGroupContext.Provider
        value={{ current, onChange, collapsibleStyle }}
        {...props}
    />
);

export const CollapsibleGroupItem = ({ name, className = "", ...props }) => (
    <CollapsibleGroupContext.Consumer>
        {({ current, onChange, collapsibleStyle }) => (
            <UncontrolledCollapsibleContainer
                className={`${className}`}
                isExpanded={name === current}
                onToggle={(isOpen) =>
                    isOpen ? onChange(name) : onChange(undefined)
                }
                {...{ collapsibleStyle }}
                {...props}
            />
        )}
    </CollapsibleGroupContext.Consumer>
);

const CollapsibleGroup = ({ initial, ...props }) => {
    const [current, setCurrent] = useState(undefined);
    useEffect(() => {
        setCurrent(initial);
    }, [initial]);

    return (
        <UncontrolledCollapsibleGroup
            onChange={setCurrent}
            {...{ current }}
            {...props}
        />
    );
};
CollapsibleGroup.Item = CollapsibleGroupItem;
export default CollapsibleGroup;
